<template>
	<view class="order">
		<view class="order_address">
			<view class="order_address_left">
				<image src="@/static/icon/home_ic_city@2x.png" mode="widthFix"></image>
				<text>添加收货地址</text>
			</view>
			<uni-icons type="forward" size="20" color="#999999"></uni-icons>
		</view>
		<view class="order_shop">
			<image src="@/static/uni.png" mode="widthFix"></image>
			<view class="order_shop_info">
				<view class="info">
					<text class="title">清澄白河马克杯-节日版定制节日版定制节日版定制</text>
					<text class="color">白色</text>
				</view>
				<view class="price">
					<text>29</text>
					<text>咖豆</text>
				</view>
			</view>
		</view>
		<view class="order_infos">
			<view class="order_info_top">
				<text class="label">实付款</text>
				<view class="right">
					<text>29</text>
					<text>咖豆</text>
				</view>
			</view>
			<view class="order_info_top">
				<text class="label">订单留言</text>
				<input
					type="text"
					placeholder="选填，建议与商家协商一致"
					placeholder-style="text-align: right;font-size: 28rpx;font-weight: 500;color: #999999;"
				/>
			</view>
		</view>
		<view class="order_footer">
			<view class="order_footer_price">
				<text>29</text>
				<text>咖豆</text>
			</view>
			<view class="order_footer_submit">
				提交订单
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.order {
		width: 100%;
		.order_address {
			width: 100%;
			height: 84rpx;
			display: flex;
			align-items: center;
			background-color: #ffffff; 
			.order_address_left {
				display: flex;
				align-items: center;
				image {
					width: 21rpx;
					height: 26rpx;
				}
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
		}
		.order_shop {
			padding: 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			display: flex;
			align-items: center;
			image {
				flex-shrink: 0;
				border-radius: 10rpx;
				width: 190rpx;
				height: 190rpx;
				margin-right: 30rpx;
			}
			.order_shop_info {
				flex: 1;
				height: 190rpx;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.info {
					width: 100%;
					display: flex;
					flex-direction: column;
					.title {
						width: 450rpx;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						font-size: 28rpx;
						font-family: PingFang SC-Bold, PingFang SC;
						font-weight: bold;
						color: #333333;
					}
					.color {
						font-size: 24rpx;
						font-family: PingFang SC-Light, PingFang SC;
						font-weight: 300;
						color: #666666;
						margin-top: 14rpx;
					}
				}
				.price {
					display: flex;
					align-items: center;
					text {
						&:first-child {
							font-size: 40rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
						}
						&:last-child {
							font-size: 28rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #D20A0A;
						}
					}
				}
			}
		}
		.order_infos {
			padding: 30rpx 32rpx;
			background-color: #ffffff;
			margin-top: 16rpx;
			display: flex;
			flex-direction: column;
			.order_info_top {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 30rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				.label {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
				input {
					width: 350rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #000000;
					text-align: right;
				}
				.right {
					display: flex;
					align-items: center;
					text {
						&:first-child {
							font-size: 32rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #D20A0A;
						}
						&:last-child {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #D20A0A;
						}
					}
				}
			}
		}
		.order_footer {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			padding: 16rpx 32rpx calc(16rpx + env(safe-area-inset-bottom)) 32rpx;
			background: #FFFFFF;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.order_footer_price {
				display: flex;
				align-items: center;
				text {
					&:first-child {
						font-size: 40rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
					&:last-child {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #D20A0A;
					}
				}
			}
			.order_footer_submit {
				width: 184rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 56rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
			}
		}
	}
</style>